export function TosPage() {
  return (
    <div className="flex flex-col gap-6 grow">
      <h1>Terms of Service</h1>
      <h2>Applies to tunestr.io provided streaming providers</h2>
      <p>
        <strong>Effective Date:</strong> 2023-07-06
      </p>
      <p>
        Welcome to tunestr.io! By using our streaming service, you agree to the following Terms of Service ("Terms").
        Please read them carefully.
      </p>
      <ol className="list-disc">
        <li>
          <b>User Accounts:</b> You are responsible for maintaining the security of your account and any activities that
          occur under it.
        </li>
        <li>
          <b>User Conduct:</b> You agree not to violate any laws, infringe upon others' rights, or engage in fraudulent
          or harmful activities while using our service.
        </li>
        <li>
          <b>Prohibited Content:</b> You may not stream or upload copyrighted content unless you have obtained the
          necessary rights or permissions.
        </li>
        <li>
          <b>Termination:</b> We reserve the right to suspend or terminate your access to the service if you violate
          these Terms.
        </li>
        <li>
          <b>Disclaimer:</b> The tunestr.io service is provided "as is" without any warranties.
        </li>
        <li>
          <b>Limitation of Liability:</b> We shall not be liable for any damages arising from your use of the service.
        </li>
        <li>
          <b>Governing Law:</b> These Terms shall be governed by and construed in accordance with the applicable local
          laws, regulations, and jurisdiction where the service is accessed and used.
        </li>
        <li>
          <b>Modifications:</b> We may update these Terms from time to time, and your continued use of the service
          constitutes acceptance of the modified Terms.
        </li>
        <li>
          <b>Entire Agreement:</b> These Terms constitute the entire agreement between you and tunestr.io.
        </li>
      </ol>
      <p>
        If you have any questions or concerns, please contact us at <a href="mailto:v4v@tunestr.io">v4v@tunestr.io</a>
        .
      </p>
      <p>By using tunestr.io, you agree to abide by these Terms of Service.</p>
      <p>Enjoy your streaming experience!</p>
    </div>
  );
}
